import React from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"

import Typography from "@material-ui/core/Typography"

import * as theme from "../../../theme"

const Button = ({ button, button: { url, title } }) => {
  if (!button) {
    return null
  }
  if (url.includes("http")) {
    return (
      <External href={url}>
        <Typography variant="button" component="div" color="inherit">
          {title}
        </Typography>
      </External>
    )
  } else {
    return (
      <Internal to={url}>
        <Typography variant="button" component="div" color="inherit">
          {title}
        </Typography>
      </Internal>
    )
  }
}

export default Button

const buttonStyle = css`
  background: transparent;
  border: 2px solid ${theme.color.green};
  padding: 15px 60px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  transition: 0.2s ease-in-out;
  color: ${theme.color.primary};
  &:hover {
    background: ${theme.color.green};
    color: white;
  }
`
const External = styled.a`
  ${buttonStyle}
`
const Internal = styled(Link)`
  ${buttonStyle}
`
